import LoginCoverBloc from "../../blocs/login/LoginCoverBloc";
import RELoginBloc from "../../blocs/retirement/RELoginBloc";

export default function RELoginPage() {

    return (
        <section className="bg-glace p-y-xl">
            <div className="grid bloc-coadherent">
                <LoginCoverBloc/>
                <RELoginBloc/>
            </div>
        </section>
    )

}